window._ = require('lodash');

import getLodash from "lodash/get";
import eachRightLodash from "lodash/eachRight";
import replaceLodash from "lodash/replace";


window.trans = function (string, args) {
    let value = getLodash(window.i18n, string);

    eachRightLodash(args, (paramVal, paramKey) => {
        value = replaceLodash(value, `:${paramKey}`, paramVal);
    });

    return value;
}
/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    // window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    // require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.Vue = require('vue');
window.axios = require('axios');

// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
delete window.axios.defaults.headers.common['X-Requested-With'];

window.axios.defaults.baseURL = baseUrl;

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';

window.baseEcho = Echo;
window.Pusher = require('pusher-js');

// import VueMoment from 'vue-moment';
// import moment from 'moment-timezone';
//
// Vue.use(VueMoment, {
//     moment,
// });

import { ModalPlugin, FormSpinbuttonPlugin, PopoverPlugin, ButtonPlugin } from 'bootstrap-vue';

Vue.prototype.trans = (string, args) => {
    return window.trans(string, args);
};

// Install BootstrapVue
Vue.use(ModalPlugin);
Vue.use(FormSpinbuttonPlugin);
Vue.use(PopoverPlugin);
Vue.use(ButtonPlugin);
// Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin);

// todo need optimize import, but worked only if imported here
import VueKonva from 'vue-konva'
Vue.use(VueKonva)
